import Vue from 'vue'
import Toasted from 'vue-toasted'
import axios from '@/util/axios'
import PortalVue from 'portal-vue'
import PrettyCheckbox from 'pretty-checkbox-vue';
import ToggleButton from 'vue-js-toggle-button'
import VueNumeric from 'vue-numeric'

// Debug
Vue.config.debug = window.config.debug;
Vue.config.devtools = window.config.debug;

Vue.use(PortalVue)
Vue.use(VueNumeric);
Vue.use(ToggleButton)
Vue.use(PrettyCheckbox);

Vue.use(Toasted, {
    theme: 'acceptance-testing-software',
    position: 'bottom-right',
    duration: 6000,
})

export default class Application {

    constructor(config) {
        this.bus = new Vue()
        this.config = config
    }

    /**
     * Start the Nova app by calling each of the tool's callbacks and then creating
     * the underlying Vue instance.
     */
    liftOff() {
        let _this = this

        this.app = new Vue({
            el: '#acceptance-testing-software',
            mounted(){
                $('[data-toggle="tooltip"]').tooltip()
            },
            methods: {
                google() {
                    App.bus.$emit('google-maps-ready')
                }
            }
        })
    }

    /**
     * Return an axios instance configured to make requests to Nova's API
     * and handle certain response codes.
     */
    request(options) {
        if (options !== undefined) {
            return axios(options)
        }

        return axios
    }

    /**
     * Register a listener on Nova's built-in event bus
     */
    $on(...args) {
        this.bus.$on(...args)
    }

    /**
     * Register a one-time listener on the event bus
     */
    $once(...args) {
        this.bus.$once(...args)
    }

    /**
     * Unregister an listener on the event bus
     */
    $off(...args) {
        this.bus.$off(...args)
    }

    /**
     * Emit an event on the event bus
     */
    $emit(...args) {
        this.bus.$emit(...args)
    }
    /**
     * Show an error message to the user.
     *
     * @param {string} message
     */
    error(message) {
        Vue.toasted.show(message, { type: 'error' })
    }

    /**
     * Show a success message to the user.
     *
     * @param {string} message
     */
    success(message) {
        Vue.toasted.show(message, { type: 'success' })
    }

    /**
     * Show a warning message to the user.
     *
     * @param {string} message
     */
    warning(message) {
        Vue.toasted.show(message, { type: 'warning' })
    }

    /**
     * Register a keyboard shortcut.
     */
    addShortcut(keys, callback) {
        Mousetrap.bind(keys, callback)
    }

    /**
     * Unbind a keyboard shortcut.
     */
    removeShortcut(keys) {
        Mousetrap.unbind(keys)
    }
}
